<template>
  <SectionView class="diet" title="饮食建议" tips @tip="dialog = true">
    <template v-if="useless">
      <div class="name">不耐受食物</div>
      <ul v-if="useless.length > 0">
        <li v-for="(item, index) in useless" :key="index">
          <img :src="item.report_food_url"/>
          <span>{{item.report_food_name}}</span>
        </li>
      </ul>
      <div v-else class="empty">未见不耐受食物</div>
    </template>

    <template v-if="useful && useful.length > 0">
      <div class="name">适用食物</div>
      <ul>
        <li v-for="(item, index) in useful" :key="index">
          <img :src="item.report_food_url"/>
          <span>{{item.report_food_name}}</span>
        </li>
      </ul>
    </template>

    <!-- 弹窗 -->
    <dialog-view title="饮食建议" v-model="dialog">
      每日进行食物适应性测试，按照每日建议饮食定时定量，全面均衡，严禁食用不耐受食物。
    </dialog-view>
  </SectionView>
</template>

<script>
  import SectionView from "@/components/SectionView";
  import DialogView from "./DialogView";

  /**
   * 饮食建议卡片
   */
  export default {
    name: "DietCard",
    components: {DialogView, SectionView},

    props: {
      // 耐受食物
      useful: {
        type: Array,
        require: false
      },
      // 不耐受食物
      useless: {
        type: Array,
        require: false
      }
    },

    data() {
      return {
        dialog: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .diet {
    .name {
      padding: 40px 0 20px 0;
      height: 34px;
      font-size: 28px;
      color: #333333;
      line-height: 34px;

      &:first-child {
        padding-top: 0;
      }
    }

    ul {
      background: #F5F6F9;
      border-radius: 10px;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding: 0 20px 30px 20px;

      li {
        flex-shrink: 0;
        width: 50%;
        height: 60px;
        display: flex;
        align-items: center;
        padding-top: 30px;

        &:first-child {
          margin-top: 0;
        }

        img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          border-radius: 10px;
          border: 1px solid #DDDDDD;
          margin-right: 10px;
          box-sizing: border-box;
        }
      }
    }

    .empty {
      width: 630px;
      height: 80px;
      background: #F5F6F9;
      border-radius: 20px;
      font-size: 32px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>